import i18n from 'i18next';
import {getCurrentLocale} from '../helpers';
import {AgreementClause} from '@chekin/core';
import {AgreementClauseKeyFormName} from '../constants';

export function getAgreementClausesData(agreementClause: AgreementClause) {
  const language = getCurrentLocale().toUpperCase();
  const body = agreementClause.body_translations[language] || agreementClause.body;

  return {
    body,
    name: `${AgreementClauseKeyFormName}${agreementClause.id}`,
    required: agreementClause.is_required
      ? i18n.t('cheking_this_clause_is_required')
      : false,
  };
}
